export default __webpack_public_path__ + "static/media/greyTwitter.c31b9a78.svg";